module.exports = __webpack_public_path__ + "d792a1637809b42dc81917a66472ae53.svg";